import "common/styles/style";

import { StencilProvider, ThemeMode } from "@amzn/stencil-react-components/context";
import { UxmStencilProvider } from "@amzn/uxm-stencil-react-components/lib/src/uxm/provider";
import AuthLoading from "common/components/AuthLoading";
import { initAnalytics } from "common/helpers/analytics-helper";
import { config, getUxmStage } from "config";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Routes from "view/Routes";

import { Provider } from "./init/providers/Provider";

initAnalytics();

export const AppWithStencil = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isAiForMePage, setIsAiForMePage] = useState(false);

  useEffect(() => {
    const checkPath = () => {
      const isAiForMe = window.location.pathname.startsWith("/aiforme");
      setIsAiForMePage(isAiForMe);

      if (isAiForMe) {
        const savedTheme = localStorage.getItem("aiforme-theme");
        setIsDarkMode(savedTheme === "dark");
      } else {
        setIsDarkMode(false);
      }
    };

    checkPath();
    const handlePopState = () => checkPath();
    window.addEventListener("popstate", handlePopState);

    const observer = new MutationObserver(() => {
      checkPath();
    });

    const body = document.querySelector("body");
    if (body) {
      observer.observe(body, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
      observer.disconnect();
    };
  }, []);

  const handleDarkModeToggle = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem("aiforme-theme", newTheme ? "dark" : "light");
  };

  return (
    <StencilProvider themeMode={isAiForMePage && isDarkMode ? ThemeMode.Dark : ThemeMode.Light} mode="dense">
      <UxmStencilProvider appId={config.analytics.uxmAppId} stage={getUxmStage()}>
        <Provider>
          <AuthLoading>
            <Routes isDarkMode={isDarkMode} onDarkModeToggle={handleDarkModeToggle} isAiForMePage={isAiForMePage} />
          </AuthLoading>
        </Provider>
      </UxmStencilProvider>
    </StencilProvider>
  );
};

ReactDOM.render(<AppWithStencil />, document.getElementById("app"));
